// Mirror of internal/i18n/languages.go: adding a language is a row in both, plus its phrase file.

/** A BCP 47 code from LANGUAGES. */
export type LanguageCode = string

export interface LanguageInfo {
  code: LanguageCode
  /** In English. */
  name: string
  /** In itself, as a language button shows it. */
  native: string
  rtl?: boolean
}

/** The language every phrase is written in first; a missing word falls back to it. */
export const SOURCE_LANGUAGE: LanguageCode = 'en'

export const LANGUAGES: readonly LanguageInfo[] = [
  { code: 'en', name: 'English', native: 'English' },
  { code: 'az', name: 'Azerbaijani', native: 'Azərbaycanca' },
  { code: 'ru', name: 'Russian', native: 'Русский' },
  { code: 'tr', name: 'Turkish', native: 'Türkçe' },
  { code: 'pl', name: 'Polish', native: 'Polski' },
  { code: 'fil', name: 'Filipino', native: 'Filipino' },
  { code: 'de', name: 'German', native: 'Deutsch' },
  { code: 'fr', name: 'French', native: 'Français' },
  { code: 'es', name: 'Spanish', native: 'Español' },
  { code: 'uz', name: 'Uzbek', native: 'Oʻzbekcha' },
  { code: 'kk', name: 'Kazakh', native: 'Қазақша' },
  { code: 'ka', name: 'Georgian', native: 'ქართული' },
]

export const isKnownLanguage = (code: string): boolean => LANGUAGES.some((l) => l.code === code)

/** An organisation's languages (GET/PUT /organisation/languages). */
export interface LanguageSettings {
  /** Staff screens until a person picks in the top-bar menu. */
  staff: LanguageCode
  /** Kiosk, displays, tickets, booking, messages; first is the default. */
  customer: LanguageCode[]
}
